import type {GetBuildApiArg} from '../../../services/rest'
import type {BuildId} from '../../../types'

const artifactsFields = 'state,artifacts(count)'

export const getBuildArtifactsArg = (buildId: BuildId): GetBuildApiArg => ({
  buildLocator: `id:${buildId}`,
  fields: `id,${artifactsFields}`,
})
